// extracted by mini-css-extract-plugin
module.exports = {"elements":"Dropdown-module--elements--tIlSS","img":"Dropdown-module--img--kPp2A","mainTitle":"Dropdown-module--mainTitle--BdxqD","element":"Dropdown-module--element--2EeKj"};